import React from 'react'

const Triangle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="7"
      viewBox="0 0 12 8"
      className="triangle"
    >
      <g>
        <g transform="rotate(180 6 4)">
          <g>
            <path d="M11.895 7.138L6.625.276c-.283-.368-.967-.368-1.25 0L.105 7.138C-.186 7.518.163 8 .73 8h10.54c.567 0 .916-.483.625-.862z" />
          </g>
        </g>
        <g transform="rotate(180 6 4)">
          <g>
            <path d="M11.895 7.138L6.625.276c-.283-.368-.967-.368-1.25 0L.105 7.138C-.186 7.518.163 8 .73 8h10.54c.567 0 .916-.483.625-.862z" />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Triangle
